var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "fixed top-54 left-108 z-10 grid place-items-center",
              style: {
                background: "rgba(255,255,255, 0.5)",
                width: "calc(100vw - 22rem - 5rem - 0.5rem)",
                height: "calc(100vh - 13.5rem - 0.5rem)"
              }
            },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "h-12 flex sticky z-20 top-42 bg-slate-200" },
        [
          _c("div", {
            staticClass:
              "h-12 w-20 sticky z-10 left-88 flex-shrink-0 bg-slate-200 border-b border-slate-400"
          }),
          _vm._v(" "),
          _vm._l(_vm.headers, function(n, idx) {
            return _c(
              "div",
              {
                key: idx,
                staticClass:
                  "h-12 py-1 px-2 flex-shrink-0 flex items-center justify-center border-b border-slate-400",
                style: { width: "calc(" + _vm.slotWidth }
              },
              [
                n.highlight
                  ? _c(
                      "div",
                      { staticClass: "h-7 flex items-center gap-1" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: n.label.split(" ")[0] }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "h-7 w-7 flex items-center justify-center rounded-full bg-light-purple-400"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-pure-white",
                              attrs: { text: n.label.split(" ").pop() }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm.enableBranch && n.branch
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "h-7 px-2 flex items-center justify-center rounded truncate",
                        style: {
                          backgroundColor: n.branch.background_color || "unset"
                        },
                        attrs: { title: n.label + " - " + n.branch.name }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "whitespace-no-wrap truncate",
                          style: { color: n.branch.color || "unset" },
                          attrs: { text: n.label }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "h-7 truncate px-4",
                        attrs: { title: n.label }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate",
                          attrs: { text: n.label }
                        })
                      ],
                      1
                    )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col relative bg-slate-200" },
        [
          _vm._l(_vm.clockRound, function(time) {
            return _c(
              "div",
              {
                key: time,
                staticClass: "flex",
                attrs: { id: "time_view_" + time }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-20 py-2 px-3 flex-shrink-0 sticky z-10 left-88 bg-slate-200 flex justify-end border-b border-r border-slate-400 transition-all duration-300",
                    style: { height: _vm.slotHeight * 2 + "rem" }
                  },
                  [_c("BlTextBody2", { attrs: { text: time } })],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.headers, function(n, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass:
                        "flex-shrink-0 flex flex-col gap-2 items-center justify-center border-b border-r border-slate-400 bg-slate-200 transition-all duration-300",
                      style: {
                        height: _vm.slotHeight * 2 + "rem",
                        width: "calc(" + _vm.slotWidth
                      }
                    },
                    _vm._l([time, time.split(":")[0] + ":30"], function(item) {
                      return _c(
                        "div",
                        {
                          key: item,
                          staticClass:
                            "rounded-2xl border-2 border-dashed border-light-purple cursor-pointer flex flex-col items-center justify-center gap-1 opacity-0 hover:opacity-100 transition-all duration-300 bg-diagonal-stripes",
                          style: {
                            height: _vm.slotHeight + "rem",
                            width: "calc(100% - 0.5rem)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onOpenSlot({
                                dimension: _vm.dimension,
                                time: item,
                                header: n
                              })
                            }
                          }
                        },
                        [
                          !_vm.isCompact
                            ? _c(
                                "div",
                                { staticClass: "text-2xl text-light-purple" },
                                [_vm._v("+")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-light-purple",
                            attrs: { text: "Reserve room" }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "absolute flex items-center",
                  style: {
                    opacity: _vm.currentTime.opacity,
                    top: _vm.currentTime.top,
                    left: "calc(" + _vm.currentTime.left,
                    zIndex: 1
                  }
                },
                [
                  _c("div", {
                    staticClass: "rounded h-2 w-2 flex-shrink-0 bg-red-cherry"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "h-1 bg-red-cherry",
                    style: { width: "calc(" + _vm.currentTime.width }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.slots, function(item, idx) {
            return _c("AvailabilitiesSlot", {
              key: idx,
              attrs: {
                isCompact: _vm.isCompact,
                item: item,
                headers: _vm.headers,
                slotHeight: _vm.slotHeight,
                slotWidth: _vm.slotWidth
              },
              on: {
                "after-commit": function($event) {
                  return _vm.$emit("after-commit")
                }
              }
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "fixed bottom-0 right-0 z-40 p-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-25 w-25 flex flex-col items-center justify-center gap-1 bg-light-purple hover:bg-dark-purple-200 rounded-full border-2 border-pure-white shadow-lg cursor-pointer",
                attrs: { title: "New Availability" },
                on: {
                  click: function($event) {
                    return _vm.onOpenSlot({ dimension: "" })
                  }
                }
              },
              [
                _c("div", { staticClass: "text-2xl text-pure-white" }, [
                  _vm._v("+")
                ]),
                _vm._v(" "),
                _c("BlTextSubtitle3", {
                  staticClass: "text-pure-white",
                  attrs: { text: "New" }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.newAvailabilitiesOpened
        ? _c("NewAvailabilitiesModal", {
            attrs: {
              selectedTherapist: _vm.newAvailabilities.therapist,
              selectedRoom: _vm.newAvailabilities.room,
              selectedStartDate: _vm.newAvailabilities.startDate,
              selectedStartTime: _vm.newAvailabilities.startTime
            },
            on: {
              "close-modal": function($event) {
                _vm.newAvailabilitiesOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-631ee25a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631ee25a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/timeslot/Timeslots.vue
// module id = null
// module chunks = 